import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Business } from '../_types/business';
import { BusinessService } from '../_services/business.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { first, firstValueFrom } from 'rxjs';
import { BusinessBankAccountComponent } from '../business-bank-account/business-bank-account.component';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { BusinessBankAccountsService } from '../_services/business-bank-accounts.service';
import { CountriesService } from '../../common/_services/countries.service';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { AddressesService } from '../../common/_services/addresses.service';
import { Address } from '../../common/_types/address';
import { CountriesRegionsService } from '../../common/_services/countries-regions.service';
import { File } from '../../common/_types/file'
import { environment } from 'src/environment/environment';
import { FilesService } from '../../common/_services/files.service';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-business-detail',
    templateUrl: './business-detail.component.html',
    styleUrls: ['./business-detail.component.scss'],
    standalone: false
})
export class BusinessDetailComponent {
  public businessFormGroup!: RxFormGroup

  public business: Business = new Business();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  public businessBankAccounts: any = [];
  public businessAddresses: any = [];
  public countries: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  public countriesRegions: any = [];
  public file: File = new File();
  public certificateFile: File | null = null;
  public imagesUrl: string = environment.api_gw + 'common/files/';
  
  constructor(
    private businessService: BusinessService,
    private messageService: MessageService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private businessBankAccountService: BusinessBankAccountsService,
    private addressesService: AddressesService,
    private countriesService: CountriesService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private countriesRegionsService: CountriesRegionsService,
    private filesService: FilesService,
    private loginService: LoginService
  ) {

    this.businessFormGroup = this.formBuilder.formGroup<Business>(this.business) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de sociedad");
    this.topbarService.addBreadcrumb("Sociedades", "/business");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadBusiness(id);
    }
    if (this.business.address == null) this.business.address = new Address();
    this.loadBusinessAddresses();
    this.loadCountries();
    this.loadCountriesRegions();
    this.allowWrite = this.loginService.hasPermission("BUSINESS.WRITE");
    this.allowDelete = this.loginService.hasPermission("BUSINESS.DELETE");
  }

  async loadBusiness(id: string) {
    this.business = await firstValueFrom(this.businessService.get(id, { include: ['address', 'certificateFile'] }));
    this.businessFormGroup.patchValue(this.business);

    this.loadBusinessBankAccounts();
  }

  async loadBusinessAddresses() {
    let response = await firstValueFrom(this.addressesService.all());
    this.businessAddresses = response.data;
  }

  async loadCountries() {
    let countryId = null;
    if (this.businessFormGroup.value.address?.countryRegionId != null) {
      let country = this.countriesRegions.find((m: any) => m.id == this.business.address?.countryRegionId);
      if (country != null) countryId = country.countryId;

    }

    let filters = {
      id: new Filter(FilterOperation.equals, 'id', "", countryId)
    };
    let params: IParamsCollection = {
      sort: ['name'],
    };
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.countriesService.all(params));
    this.countries = response.data;
  }

  async loadCountriesRegions() {
    let params: IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.countriesRegionsService.all(params));
    this.countriesRegions = response.data;
  }


  async loadBusinessBankAccounts() {
    let filters = {
      businessId: new Filter(FilterOperation.equals, 'businessId', "", this.business.id)
    };
    let params: IParamsCollection = {
      include: ['bank']
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.businessBankAccountService.all(params));
    this.businessBankAccounts = response.data;
    this.totalRecords = response.meta['total'];
  }

  async onFileSelect(event: any) {
    let files = event.files;
    for (let file of files) {
      this.file = file;
    }
  }
  async onCertificateFile(event: any){
    let filesC = event .files;
    for (let file of filesC) {
      this.certificateFile = file;
    }
  }

  async deleteLogo(){
    this.business.logoId = null;
    this.businessFormGroup.patchValue({ logoId: null });
  }

  async deleteCertificate(){
    this.business.certificateFileId = null;
    this.businessFormGroup.patchValue({ certificateFileId: null });
    this.certificateFile = null;

  }
  async save() {
    let valid = this.formValidationService.validateForm(this.businessFormGroup);
    if (valid) {
      this.business = Object.assign(this.business, this.businessFormGroup.value);
      
      //imagen
      if(this.business.logoId == null ){
        let data: File = new File();
        data.fileName = this.business.name + "_logo";
        data.size = this.file.size;
        data.contentType = this.file.type;
  
        //creamos el file
        let fileResponse = await firstValueFrom(this.filesService.save(data));
  
        //subimos el fichero al file
        let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, this.file));
  
        //guardamos el file en el expediente
        this.business.logoId = fileResponse.id as string;       
      }

       //Certificado
      if(this.certificateFile != null ){

        let data: File = new File();
        data.fileName = this.business.name + "_certificate";
        data.size = this.certificateFile.size;
        data.contentType = this.certificateFile.type;
  
        //creamos el file
        let fileResponse = await firstValueFrom(this.filesService.save(data));
  
        //subimos el fichero al file
        let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, this.certificateFile));
  
        //guardamos el file en el expediente
        this.business.certificateFileId = fileResponse.id as string;       
      }

      
      if (this.business.address != null) {
        let address: any = await firstValueFrom(this.addressesService.save(this.business.address));
        this.business.addressId = address.id;
      }

      await firstValueFrom(this.businessService.save(this.business));

      this.messageService.add({ closable: true, severity: 'success', summary: "Sociedad guardada correctamente." });
      this.router.navigate(['business']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la sociedad?",
      header: "Eliminar sociedad",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.businessService.delete(this.business.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Sociedad eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['business']);
  }

  async editBankAccount(businessBankAccount: any) {
    let ref = this.dialogService.open(BusinessBankAccountComponent, {
      closable: true,
      modal: true,
      header: 'Editar cuenta bancaria de la sociedad',
      width: '500px',
      data: {
        businessBankAccountId: businessBankAccount ? businessBankAccount.id : null,
        businessId: this.business.id
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadBusinessBankAccounts();
    });
  }

  async deleteBankAccount(businessBankAccount: any) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la cuenta bancaria de la sociedad?",
      header: "Eliminar cuenta bancaria",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.businessBankAccountService.delete(businessBankAccount.id).subscribe({
          next: (data: any) => {
            this.loadBusinessBankAccounts();
            this.messageService.add({ closable: true, severity: 'success', detail: "Cuenta bancaria eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

 
  downloadFile(fileId?: string) {
    if(fileId != null && fileId!=""){
      this.filesService.download(fileId);
    }
  }

}
